import React from 'react'
import { Heading } from '@myxplor/ui'
import { Loading } from '@myxplor/ui'
import ACCSForm from '../../../../accs/form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import LocalAsyncStore from '../../../../../local-async-store'
import {submissionToForm} from '../../../../../accs-gov-enrolments/helpers'

const available = (record) => hasAvailableAction(record, 'view_submission')

const apiEndPoint = (regHolderId, {gov_id, type}) => 
  `/api/services/${regHolderId}/accs/${type.toLowerCase()}/${gov_id}/submission`

const actionForm = ({child, record}) => ({async}) => {
  if (async.loading || !async.data)
    return <Loading>Fetching submission...</Loading>

  if(!async.success)
    return (<Heading small>Fetching submission failed</Heading>)

  return (
    <ACCSForm 
      values={submissionToForm(child, async.data)}
      child={child}
      isDetermination={record.type === 'DETERMINATION'}
      onChange={()=>{}}
      readOnly={true}
    />
  )
}

const formWrapper = ({ regHolderId, child, record }) =>
  LocalAsyncStore('async', actionForm({child, record}), () => apiEndPoint(regHolderId, record))

export const viewSubmission = ({ regHolderId, child, record }) => {
  return available(record)
    ?
    {
      label: 'View Submission',
      value: 'view_submission',
      actionForm: formWrapper({ regHolderId, child, record }),
      onCompletePreserveAction: true,
      onComplete: () => true,
    }
    : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/view-submission/index.js